/*
*
* File JS componente Messages
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './messages.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const messages = () => {
    const closeBtn = document.querySelector('.messages .messages__close');

    if (closeBtn)
    {
        closeBtn.addEventListener('click', (evt) => {
            evt.preventDefault();

            let messagesWrap = evt.target.closest('.messages');

            messagesWrap.style.opacity = 0;
            messagesWrap.style.visibility = 'hidden';

            console.log(evt.target.closest('.messages'));
        });
    }
}

export default messages;

//--------------------------------------------------------------------//